// extracted by mini-css-extract-plugin
module.exports = {"label":"Radio_label__32t9M"};